<template>
  <div>
    <el-table ref="table" :data="items" border fit highlight-current-row style="width: 100%" height="575">
      <el-table-column width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.excludedYN"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.finish')" min-width="150">
        <template slot-scope="scope">
          <span>
            {{ scope.row.description }} <i>{{ scope.row.finishTypeDescription }}</i>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    value(value) {
      this.items = value;
    }
  }
};
</script>
